/**
 * Router for Appointments
 */

import { Navigate } from 'react-router-dom'

import { BookingFlow } from './booking/BookingFlow'

import type { RouteObject } from 'react-router-dom'

const appointmentRoutes: RouteObject[] = [
  {
    path: 'appointment',
    children: [
      {
        path: 'book',
        element: <BookingFlow />,
      },
      {
        index: true,
        path: '*',
        element: <Navigate to='book' replace />,
      },
    ],
  },
]

export { appointmentRoutes }
